import {ApiException} from '@toolify/server/src/middleware/ApiResponseMiddleware/errors/ApiException'
import {i18n} from '@toolify/client/src/setup/i18n'
import {getPolicyLimitExceededToastMessage} from '@toolify/client/src/modules/billing/helpers/getPolicyLimitExceededToastMessage'
import {
  getBillingLinkAction,
  getWorkspaceUpgradeHref,
} from '@toolify/client/src/modules/billing/helpers/getWorkspaceBillingBlockedMessage'
import {useWorkspaceStore} from '@toolify/client/src/stores/WorkspaceStore/useWorkspaceStore'
import {useMessages} from '@toolify/client/src/modules/notifications/composables/useMessages'

const messages = useMessages()

export const POLICY_LIMIT_TOAST_REPLACE_KEY_PREFIX = 'quota.'

// The user has to act (upgrade), so with a link the card stays until closed; a newer limit error
// for the same limit replaces it in place with fresh numbers
export function showPolicyLimitExceededToast(apiException: ApiException): void {
  const workspaceName = useWorkspaceStore().currentWorkspace?.name
  const text = getPolicyLimitExceededToastMessage(apiException, i18n.global.t)
  const upgradeAction = getBillingLinkAction(
    workspaceName ? getWorkspaceUpgradeHref(workspaceName) : null,
    i18n.global.t('workspaceUpgrade.upgradePlan'),
  )
  const policyLimitType = (apiException.extra as {policyLimitType?: string} | undefined)?.policyLimitType
  const replaceKey = `${POLICY_LIMIT_TOAST_REPLACE_KEY_PREFIX}${policyLimitType ?? 'generic'}`
  if (!upgradeAction) {
    messages.error(text, {replaceKey})
    return
  }
  messages.error(text, {
    duration: 0,
    pinned: true,
    replaceKey,
    actions: [upgradeAction],
  })
}
